import { createContext, useContext } from 'react'
import type { TelemetryPort } from '@/domain/telemetry/TelemetryPort'

export const TelemetryContext = createContext<TelemetryPort | null>(null)

export function useTelemetry(): TelemetryPort {
  const telemetry = useContext(TelemetryContext)
  if (!telemetry) {
    throw new Error('useTelemetry must be used inside <TelemetryProvider>')
  }
  return telemetry
}
